import React, { FC, useRef, useState } from 'react';
import { addComma } from 'src/utils/common';
import IconButton from 'src/components/atoms/buttons/IconButton';
import NoResult from 'src/components/molecules/table/NoResult';

interface Props {
  data: any;
  viewType?: string;
  modifyItemEvt: (item: any) => void;
  deleteItemEvt: (item: any) => void;
}
const GridList: FC<Props> = ({ data, viewType, modifyItemEvt, deleteItemEvt }) => {
  const viewData: any = [];
  data.forEach((item: any, idx: number) => {
    const infoData = item.infoData || [];
    infoData.forEach((info: any, i: number) => {
      const setItem = {
        ...item,
        infoData: info,
      };
      viewData.push(setItem);
    });
  });

  const setData = [];
  const deleteEvt = (item: any) => {
    deleteItemEvt(item);
  };
  const modifyEvt = (item: any) => {
    modifyItemEvt(item);
  };
  const viewDataType = (item: any) => {
    let typeView = '';
    switch (item) {
      case '1':
        typeView = '본인(대학원등..)';
        break;
      case '2':
        typeView = '취학전아동';
        break;
      case '3':
        typeView = '초,중,고등학교 / 중,고생 교복비 / 초·중·고 체험학습비';
        break;
      case '4':
        typeView = '대학교(대학원 불포함)';
        break;
      case '5':
        typeView = '장애인 특수교육비';
        break;
      default:
        typeView = '';
        break;
    }
    return typeView;
  };
  return (
    <div className="_table_grid_layout _education_list_grid">
      <div className="_grid">
        <div className="_label">
          <div className="_row _i_h3">
            {viewType === 'modify' ? (
              <>
                <div className="_col _wd_n01 _hd_n01">
                  <div className="_tit"></div>
                </div>
              </>
            ) : (
              ''
            )}
            <div className="_col _wd_n0">
              <div className="_cont">대상자</div>
            </div>
            <div className="_col _wd_n2">
              <div className="_cont">자료유형</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">국세청 자료 여부</div>
            </div>
            <div className="_col _wd_n4">
              <div className="_cont">PDF제외금액</div>
            </div>
            <div className="_col _wd_n4">
              <div className="_cont">지출금액(국세청)</div>
            </div>
            <div className="_col _wd_n4">
              <div className="_cont">지출금액(기타)</div>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div className="_content">
          {viewData.map((item: any, idx: number) => {
            const infoData = item.infoData || {};
            return (
              <div className="_row _i_h2" key={idx}>
                {viewType === 'modify' ? (
                  <>
                    <div className="_col _wd_n01">
                      <div className="_cont">
                        <div className="_i_row ">
                          <div className="_i_col _w_p_50  _bor_r">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => modifyEvt(item)}
                                icon="ri-edit-box-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                          <div className="_i_col _w_p_50">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => deleteEvt(item)}
                                icon="ri-delete-bin-2-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
                <div className="_col _wd_n0">
                  <div className="_cont">{item.name}</div>
                </div>
                <div className="_col _wd_n2">
                  <div className="_cont">{viewDataType(infoData.data_type)}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{infoData.is_htx_pdf === 'Y' ? '국세청제공' : '-'}</div>
                </div>
                <div className="_col _wd_n4">
                  <div className="_cont">{addComma(infoData.htx_expt_amt)}</div>
                </div>
                <div className="_col _wd_n4">
                  <div className="_cont">{addComma(infoData.htx_amt)}</div>
                </div>
                <div className="_col _wd_n4">
                  <div className="_cont">{addComma(infoData.amt)}</div>
                </div>
              </div>
            );
          })}
          {viewData.length === 0 ? <NoResult /> : ''}
        </div>
      </div>
    </div>
  );
};

export default GridList;
